export default "__VITE_ASSET__BFVLf6Ag__"